// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const WrapperValidation = styled.div<{
  isDark?: boolean;
  state?: boolean | undefined;
}>(
  ({ theme, isDark, state }) => css`
    border: 1px solid
      ${
        isDark
          ? state !== undefined
            ? state
              ? theme.colors.primary.lighter
              : theme.colors.red.light
            : theme.colors.gray['lighter-dark-mode']
          : state !== undefined
            ? state
              ? theme.colors.primary.light
              : theme.colors.red.main
            : theme.colors.gray.main
      };
    background-color: ${
      state !== undefined
        ? state
          ? theme.colors.primary['lighter-12']
          : 'rgba(254, 213, 227, 0.1);'
        : theme.colors.gray['dark-8']
    };
  `,
);
